import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { LifeStyleSubCategoryEnum } from '@classifieds-sell/datalayer';
import { Subject, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormHelperService } from '../../../helpers/form-helper.service';
import {
    DraftFacade,
    RouterFacade,
    IRouterData
} from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-sale-attribute-section',
    templateUrl: './property-sale-attribute-section.component.html',
    styleUrls: ['./property-sale-attribute-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertySaleAttributeSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    private _destroyed$: Subject<void> = new Subject<void>();

    @ViewChild('propertySaleAttributeSectionForm')
    propertySaleAttributeSectionForm: NgForm;
    routerData: IRouterData;
    isDwellingSubcategory: boolean;

    constructor(
        public draftFacade: DraftFacade,
        private changeDetectorRef: ChangeDetectorRef,
        private formHelperService: FormHelperService,
        public routerFacade: RouterFacade
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.getRouteData();
            this.changeDetectorRef.markForCheck();
        });
    }

    getRouteData(): void {
        from(this.routerFacade.routerData$)
            .pipe(takeUntil(this._destroyed$))
            .subscribe((routerStateData) => {
                this.routerData = routerStateData;
                this.isDwellingSubcategory = this.routerData.subCategory === LifeStyleSubCategoryEnum.dwelling;
            });
    }

    isValid(): boolean {
        this.formHelperService.validate(
            this.propertySaleAttributeSectionForm
        );
        return this.propertySaleAttributeSectionForm.form.valid;
    }

    dirty(): boolean {
        return this.propertySaleAttributeSectionForm.form.dirty;
    }
}
